module.exports = __webpack_public_path__ + "img/image-02.8107bc5e.webp";